import { APIEndpointEnum } from 'config/constants/server'
import { HunnyPlayRequest } from './HunnyPlayRequest'
import { BaseResponse, HunnyRequest, SurveyTypeEnum } from './types'

class SurveyService extends HunnyPlayRequest {
  public userSurvey({
    answer,
    targetId,
    surveyCode,
  }: {
    answer: Record<string, number>
    targetId?: string
    surveyCode: SurveyTypeEnum
  }): HunnyRequest<BaseResponse<any>> {
    const result = this._post(
      APIEndpointEnum.UserSurvey,
      {
        answer,
        target_id: targetId?.toString() || '',
        survey_code: surveyCode,
      },
      { authRequest: true },
    )
    return result
  }

  public checkSurvey(survey_code: SurveyTypeEnum): HunnyRequest<BaseResponse<{ isAnswered: boolean }>> {
    const result = this._post(APIEndpointEnum.CheckSurvey, { survey_code }, { authRequest: true })
    return result
  }
}

const instance = new SurveyService()
export default instance
